import styled from 'styled-components';

export const MapContainer = styled.div`
  & > div {
    @media (max-width: 480px) {
      min-width: unset !important;
      height: 450px !important;
    }
  }
`;
